import { TComputedPropMapper } from '../../types/computed-props-mapper';
import { isFromBuilder } from './agent/isFromBuilder';
import { isFromSeller } from './agent/isFromSeller';
import { isPro } from './agent/isPro';
import { isAgent } from './isAgent';

export const isProAgent: TComputedPropMapper<boolean> = (...args) => {
  return isAgent(...args) && isPro(...args) && !(isFromBuilder(...args) || isFromSeller(...args));
};
